import React from "react";
import { useState } from "react";
import { usePageSearchState } from "../../../../db";
import { mobile, parseStyle, decodeStyle, tablet } from "../../../../juntion";
import QurealForm from "../../../../../forms/QurealForm";
import { useAction } from "../../../../hooks";

function Form({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];
    const { performAction } = useAction();

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    // log.d(input, "Form Input");

    return (
        <div>
            <QurealForm
                id={input.form}
                org={ctx.organization}
                // id={12}
                // record_id={2}
                wrapper_style={{
                    background: "white",
                    fontSize: input.fontSize,
                    fontWeight: input.bold ? "bold" : "normal",
                    textTransform: input.uppercase ? "uppercase" : "none",
                    ...decodeStyle(ps.fixStyle, gs),
                    ...decodeStyle(ps.style, gs),
                    ...(tablet(device) && decodeStyle(tabletStyle, gs)),
                    ...(mobile(device) && decodeStyle(mobileStyle, gs)),
                }}
                configs={{
                    submitButtonText: input.submitButtonText,
                    submittingButtonText: input.submittingButtonText,
                    successMessage: input.successMessage,
                }}
                onSuccess={() =>
                    performAction({
                        ...input.actionOnSuccess,
                        dydb: dydb,
                    })
                }
            />
        </div>
    );
}

export default Form;
